export const ColorsBase = {
    blue1: '#99c4c8',
    blue2: '#4e8ba8',
    blue3: '#0078ff',
    green1: '#84bab6',
    yellow1: '#f7d198',
    yellow2: '#f5c79c',
    orange1: '#f5beaa',
    pink1: '#f7cdcf',
    pink2: '#f1acb8',
    pink3: '#ff2351',
    purple1: '#bfa7c1',
    purple2: '#c3abc5',
    grey: '#313131',
    halftoneDotColor: 'rgba(255, 255, 255, 0.05)',
}